import React from "react";
import { rateSetModel } from "../rateSetModel";
import { ISearchField, SearchTypeEnum } from "@components/YhPageHeader/Types";
import { YhPageHeader } from "@components/YhPageHeader";



export function PageHeader() {
    const {
        searchParam,
        onReset,
        loadData,
        updateSearchParam,
        appDs
    } = rateSetModel();

    const searchFields: ISearchField[] = [

        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "系统",
            fieldName: "appCode",
            size: "small",
            disabled: false,
            options: appDs
        },
    ]


    return (
        <YhPageHeader
            title="评价设置"
            searchValues={searchParam}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={onReset}
        />
    );
}